"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fraction = void 0;
exports.Fraction = {
    parse: function (s) {
        var whole = 0;
        var top = 0;
        var bottom = 0;
        var tokens = s.split(' ');
        tokens.forEach(function (token) {
            if (token.includes('/')) {
                top = parseInt(token.split('/')[0]);
                bottom = parseInt(token.split('/')[1]);
            }
            else {
                whole = parseInt(tokens[0]);
            }
        });
        return {
            whole: whole,
            top: top,
            bottom: bottom
        };
    },
    toFractionString: function (f) {
        var fString = '';
        if (f.whole) {
            fString = fString + f.whole;
        }
        if (f.top) {
            if (f.whole) {
                fString = fString + ' ' + f.top + '/' + f.bottom;
            }
            else {
                fString = fString + f.top + '/' + f.bottom;
            }
        }
        return fString;
    },
    multiply: function (num1, num2) {
        if (typeof (num1) === 'number') {
            num1 = num1.toString();
        }
        if (typeof (num2) === 'number') {
            num2 = num2.toString();
        }
        if (num1 && num2) {
            var num1Fraction = exports.Fraction.parse(exports.Fraction.normalize(num1));
            var num2Fraction = exports.Fraction.parse(exports.Fraction.normalize(num2));
            var newValue = {
                whole: 0,
                top: num1Fraction.top * num2Fraction.top,
                bottom: num1Fraction.bottom * num2Fraction.bottom
            };
            return exports.Fraction.toFractionString(exports.Fraction.reduce(newValue));
        }
        else {
            return exports.Fraction.checkIfOneOrBothExist(num1, num2);
        }
    },
    add: function (num1, num2) {
        if (typeof (num1) === 'number') {
            num1 = num1.toString();
        }
        if (typeof (num2) === 'number') {
            num2 = num2.toString();
        }
        if (num1 && num2) {
            var num1Fraction = exports.Fraction.parse(exports.Fraction.normalize(num1));
            var num2Fraction = exports.Fraction.parse(exports.Fraction.normalize(num2));
            var newValue = {
                whole: 0,
                top: (num1Fraction.top * num2Fraction.bottom) + (num2Fraction.top * num1Fraction.bottom),
                bottom: num1Fraction.bottom * num2Fraction.bottom
            };
            return exports.Fraction.toFractionString(exports.Fraction.reduce(newValue));
        }
        else {
            return exports.Fraction.checkIfOneOrBothExist(num1, num2);
        }
    },
    checkIfOneOrBothExist: function (num1, num2) {
        if ((num1 === undefined ||
            num1 === '' ||
            num1 === null)
            && (num2 !== undefined &&
                num2 !== '' &&
                num2 !== null)) {
            console.info('The first number was null, undefined, or an empty string');
            return exports.Fraction.normalize(num2);
        }
        else if ((num2 === undefined ||
            num2 === '' ||
            num2 === null)
            && (num1 !== undefined &&
                num1 !== '' &&
                num1 !== null)) {
            console.info('The second number was null, undefined, or an empty string');
            return exports.Fraction.normalize(num1);
        }
        else {
            console.info('Both numbers were null, undefined, or an empty string');
            return '';
        }
    },
    normalize: function (f) {
        var parts = exports.Fraction.parse(f);
        if (parts.top === 0 || parts.bottom === 0) {
            return parts.whole + '/1';
        }
        else {
            parts.top = parts.top + (parts.bottom * parts.whole);
            parts.whole = 0;
            return exports.Fraction.toFractionString(parts);
        }
    },
    reduce: function (f) {
        // TODO Fix this
        var gcdf = function (a, b) {
            return b ? gcdf(b, a % b) : a;
        };
        var gcd = gcdf(f.top, f.bottom);
        var reducedTop = f.top / gcd;
        var bottom = f.bottom / gcd;
        var whole = Math.floor(f.top / f.bottom);
        var newTop = reducedTop - (bottom * whole);
        return {
            top: newTop,
            bottom: bottom,
            whole: whole
        };
    }
};
